<template>
  <div v-if="shouldShowSelfieInstructions" class="incode-instructions">
    <div class="list-group">
      <IncodeInstructionItem
        :icon-src="selfieIcon"
        icon-alt="selfie"
        :message="t('INCODE_SELFIE_INSTRUCTION')"
      />
      <IncodeInstructionItem
        :message="t('INCODE_GENERAL_ADVICE_SELFIE_INSTRUCTION')"
      />
    </div>
  </div>
  <div v-else class="incode-instructions">
    <div class="list-group">
      <IncodeInstructionItem
        :icon-src="frontIdIcon"
        icon-alt="front of ID"
        :message="t('INCODE_FRONT_ID_INSTRUCTION')"
      />
      <IncodeInstructionItem
        :icon-src="backIdIcon"
        icon-alt="Back of ID"
        :message="t('INCODE_BACK_ID_INSTRUCTION')"
      />
      <IncodeInstructionItem
        :message="t('INCODE_GENERAL_ADVICE_ID_INSTRUCTION')"
      />
    </div>
  </div>
</template>
<script setup lang="ts">
import { computed, onMounted } from "vue";
import useIncodeOnBoardStatus from "@/apps/merchant3/hooks/useIncodeOnBoardStatus";
import { useStore } from "vuex";
import { useI18n } from "@/apps/merchant3/composables/useI18n";
import useAsset from "@/apps/merchant3/shared-helpers/useAsset";
import IncodeInstructionItem from "@/apps/merchant3/components/incode/IncodeInstructionItem.vue";

const { t } = useI18n();
const store = useStore();
const frontIdIcon = useAsset("img/front_id_preview_icon_detailed.png");
const backIdIcon = useAsset("img/back_id_preview_icon_detailed.png");
const selfieIcon = useAsset("img/selfie_preview_icon_rounded.png");
const shouldShowSelfieInstructions = computed(() => {
  const onboardStatus = store.state.carts.incodeOnboardStatus;

  return (
    onboardStatus === "ID_VALIDATION_FINISHED" ||
    onboardStatus === "POST_PROCESSING_FINISHED"
  );
});

onMounted(() => {
  useIncodeOnBoardStatus();
});
</script>

<style scoped>
.incode-instructions {
  position: absolute;
  left: 16px;
  right: 16px;
}
</style>
